import { Menu } from '@mui/material';
import { useState } from 'react';
import type { Space } from '../../../models';
import { SpaceSelectList } from './SpaceSelectList';

const MENU_WIDTH = 220;

interface SpaceMenuProps {
  spaceCode: string;
  spaceOptions: Space[];
  anchorEl: HTMLElement | null;
  setAnchorEl: (el: HTMLElement | null) => void;
  onSelect: (space: Space) => Promise<void>;
  onCreate: (name: string) => Promise<void>;
}

/**
 * グローバルヘッダーの台帳切替メニュー。
 *
 * 検索 + 一覧表示そのものは副作用を持たない {@link SpaceSelectList} に委譲し、
 * ここは Menu の anchor 制御と「選択・作成したら API を呼ぶ」副作用だけを担う。
 */
function SpaceMenu(props: SpaceMenuProps) {
  const { spaceCode, spaceOptions, anchorEl, setAnchorEl, onSelect, onCreate } = props;
  // 閉じるたびに検索文字列を捨てるため、開閉ごとに SpaceSelectList を作り直す。
  const [listKey, setListKey] = useState(0);

  const onClose = () => {
    setAnchorEl(null);
    setListKey((pre) => pre + 1);
  };

  return (
    <Menu
      anchorEl={anchorEl}
      id="global-space-switch-menu"
      open={Boolean(anchorEl)}
      onClose={onClose}
      transformOrigin={{ horizontal: 'left', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
      transitionDuration={0}
      slotProps={{
        list: { disablePadding: true },
        paper: { sx: { width: `${MENU_WIDTH}px` } },
      }}
    >
      <SpaceSelectList
        key={listKey}
        spaceCode={spaceCode}
        spaceOptions={spaceOptions}
        onSelect={(option) => {
          onClose();
          void onSelect(option);
        }}
        onCreate={(name) => {
          onClose();
          void onCreate(name);
        }}
      />
    </Menu>
  );
}

export { SpaceMenu };
